<template>
    <div class="wrap">
        <div class="d-flex">
            <div class="mr-auto">
                <button class="btn btn-secondary" @click="refresh"><i class="fas fa-sync-alt"></i></button>
            </div>
            <div class="align-self-end">
                <input-debounced
                        v-model="search"
                        :clearable="true"
                        :autofocus="true"
                        placeholder="Search"
                        class="search-bar w-300 mb-2"
                ></input-debounced>
            </div>
        </div>
        <base-table
                :base-url="urlWithFilters"
                ref="baseTable"
                @load-success="onLoadSuccess"
                @refresh="onRefresh"
                :current-page="currentPage"
                v-loading="isRefreshing"
                element-loading-spinner="el-icon-loading"
        >
            <template v-slot>
                <el-table
                        :data="items"
                        stripe
                        class="w-100"
                >
                    <el-table-column
                            prop="model.id"
                            label="Id"
                            min-width="40"
                    ></el-table-column>
                    <el-table-column
                            prop="model.full_name"
                            label="Name"
                            min-width="200"
                    ></el-table-column>
                    <el-table-column
                            prop="model.email"
                            label="Email"
                            min-width="180"
                    ></el-table-column>
                    <el-table-column
                            prop="model.role.name"
                            label="Role"
                            min-width="80"
                    ></el-table-column>
                    <el-table-column
                            prop="bound"
                            label="Bound"
                            min-width="80"
                            :formatter="formatBound"
                    ></el-table-column>
                    <el-table-column
                            label="Actions"
                            v-slot="{row}"
                    >
                        <toggle-column :row="row" @toggle="onToggle"></toggle-column>
                    </el-table-column>
                </el-table>
            </template>
        </base-table>
        <el-pagination
                layout="prev, pager, next"
                :total="total"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                class="text-right"
        ></el-pagination>
    </div>
</template>

<script>
  import TableWithPagination from '../../table-with-pagination';
  import {addQueryParams} from '../../../libs/url';
  import ToggleColumn from './toggle-column';
  import eventBus from '../../../event-bus';

  export default {
    extends: TableWithPagination,

    components: {
      ToggleColumn,
    },

    data() {
      return {
        search: null,
        filters: {},
      };
    },

    computed: {
      /**
       * @return {string}
       */
      urlWithFilters() {
        return addQueryParams(this.url, this.filters);
      },
    },

    watch: {
      search: function (value) {
        this.filters = value
          ? _.assign({}, this.filters, {search: value})
          : this.filters = _.omit(this.filters, ['search']);
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.baseTable.refresh();
      },

      /**
       * @param {object} row
       * @param {object} col
       * @param {string} value
       * @return {string}
       */
      formatBound(row, col, value) {
        return value ? 'Yes' : null;
      },

      /**
       * @param {object} model
       * @return {undefined}
       */
      onToggle({model}) {
        let url = _.values({url: this.url, id: model.id}).join('/');
        return axios.get(url)
          .then(this.storeSuccess)
          .catch(this.handleErrorResponse)
          .then(() => this.refresh());
      },

      /**
       * @param {object} data
       * @return {undefined}
       */
      storeSuccess({data}) {
        let message = _.get(data, 'message');
        _.isString(message) && this.$message.success(message);
        eventBus.$emit('refresh-outgoing-number-table');
      },

      /**
       * @param data
       * @param status
       * @return {boolean}
       */
      handleErrorResponse({response: {data, status}}) {
        const {errors, message} = data || {};
        this.$message.error(message);
      }
    }
  }
</script>
